export function formConfig() {
    return {
        text: {
            fontSize: "inherit"
        }
    };
}
